import { ServiceConfig } from '@user/store/services/config'

export const filtersUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.activityHistory.filters}`
export const searchUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.activityHistory.search}`

export enum ActivityHistoryType {
  CustomActivity = 'CustomActivity',
  Agreement = 'Agreement',
  KnockStatusUpdate = 'KnockStatusUpdate',
}

export enum AuditTypeName {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
}

export const uploadedByActionVerbiage = 'Uploaded by'
export const printAndSign = 'Print and Sign'
